import { loadGoogleMapsApi, loadGoogleMapsLibrary } from './googleMapsApi';

export const createGoogleMap = async (element, options) => {
  if (!element) {
    throw new Error('A DOM element is required to create a Google Map.');
  }

  const { maps } = await loadGoogleMapsApi();
  return new maps.Map(element, options);
};

export const createGoogleMapLocationMarker = async (map, position) => {
  if (!map) {
    throw new Error('A Google Map instance is required to create a marker.');
  }

  const { OverlayView } = await loadGoogleMapsLibrary('maps');

  class LocationMarker extends OverlayView {
    constructor(markerPosition) {
      super();
      this.position = markerPosition;
      this.container = null;
    }

    onAdd() {
      this.container = document.createElement('div');
      this.container.className = 'google-location-marker';
      this.container.innerHTML = '<div class="pin"></div><div class="pulse"></div>';
      this.getPanes().overlayMouseTarget.appendChild(this.container);
    }

    draw() {
      if (!this.container) return;

      const projection = this.getProjection();
      const point = projection.fromLatLngToDivPixel(this.position);
      this.container.style.left = `${point.x}px`;
      this.container.style.top = `${point.y}px`;
    }

    onRemove() {
      if (this.container?.parentNode) {
        this.container.parentNode.removeChild(this.container);
      }

      this.container = null;
    }

    setPosition(positionToSet) {
      this.position = positionToSet;
      this.draw();
    }
  }

  const marker = new LocationMarker(position);
  marker.setMap(map);
  return marker;
};

export const geocodeLatLng = async (location) => {
  const { Geocoder } = await loadGoogleMapsLibrary('geocoding');
  const geocoder = new Geocoder();

  return geocoder.geocode({ location });
};
